import React from 'react';
import styles from './ReviewCard.module.scss';

interface ReviewCardProps {
  author: string;
  content: string;
  rating: number;
  date?: string;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ author, content, rating, date }) => {
  return (
    <div className={styles.reviewCard}>
      <div className={styles.reviewCardHeader}>
        <strong className={styles.reviewCardAuthor}>{author}</strong>
        <span className={styles.reviewCardRating}>★ {rating}/5</span>
      </div>
      <div className={styles.reviewCardContent}>{content}</div>
      {date && <div className={styles.reviewCardDate}>{date}</div>}
    </div>
  );
};

export default ReviewCard; 